import type {PartValueRenderer} from 'schema/types';

export const Counter: PartValueRenderer = ({value}) => {
  return Array.isArray(value) ? <span>{value.length.toString()}</span> : null;
};
